import { useDispatch, useSelector } from 'react-redux'
import React from 'react'

import { getDialogProps } from '~/selectors/ui'

import Slideshow from '~/components/dialogs/slideshow'
import RecordingPreview from '../recording-preview'
import RecordingVideoPlayer from '../video-player'
import { setPlayingRecording } from '~/actions/recents'
import { getPlayingRecording } from '~/selectors/recents'
import SlideshowActions from './actions'

const RecordingsSlideshow = () => {
  const dispatch = useDispatch()
  const { recording, sessionId } = useSelector(getDialogProps)
  const items = [...recording.keyMoments, recording]
  const selectedRecording = useSelector(getPlayingRecording)
  const selectedItem = selectedRecording ? items.find(i => i.url === selectedRecording.url) : items[0]

  const onSelect = item => {
    dispatch(setPlayingRecording({
      url: item.url
    }))
  }

  return (
    <Slideshow
      autoPlayNext
      onSelect={onSelect}
      selectedSlide={selectedItem}
      SelectedSlideComponent={RecordingVideoPlayer}
      SlideActions={SlideshowActions}
      SlideComponent={RecordingPreview}
      slideNameMapping='recording'
      slideProps={{
        sessionId
      }}
      slides={items}
    />
  )
}

export default RecordingsSlideshow
